import { makeStyles, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { dolphinTokens } from "../../utils/Theme";

const useStyes = makeStyles({
    contentWrapper: {
        padding: "2rem 1rem"
    },
    h2: {
        "& .highlight": {
            color: dolphinTokens.colorLightBlue,

            "@media (min-width: 1024px)": {
                display: "block"
            }
        }
    },
    h4: {
        color: "#869ab8"
    }
});

export default function Tagline() {
    const { t } = useTranslation("home");
    const styles = useStyes();
    
    return (
        <div className={styles.contentWrapper}>
            <Text block as="h2" size={800} align="center" className={styles.h2}>
                <span dangerouslySetInnerHTML={{ __html: t("tagline.h2") }} />
            </Text>
            <Text block as="h4" size={500} align="center" className={styles.h4}>
                {t("tagline.h4")}
            </Text>
        </div>
    );
}